const Common = {

    IMAGE_PERMITTED_FILE_SIZE: 500 * 1024, // em bytes (500kb)
    IMAGE_PERMITTED_WIDTH: 600,
    IMAGE_PERMITTED_HEIGHT: 450,
    IMAGE_VALID_TYPES: ['image/jpeg', 'image/png'],

    PROFILE_IMAGE_PERMITTED_WIDTH: 300,
    PROFILE_IMAGE_PERMITTED_HEIGHT: 300,
    PROFILE_IMAGE_PERMITTED_FILE_SIZE: 200 * 1024, // em bytes (200kb)

    DEFAULT_ROWS_PER_PAGE: 25,

    MAP_CENTER_POSITION: [-8.050000, -34.900002],

    MINIMUM_PASSWORD_LENGTH: 8,

    LAST_30_DAYS_FILTER: 30
}

export default Common;